import classNames from "classnames";
import React from "react";
import Customer from "./Customer";
import Target from "./Target";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels} = props;
    const CustomerComp = props.Customer || Customer;
    const TargetComp = props.Target || Target;
    return (hidden || []).indexOf("to") === -1 && <div className={classNames({
        "col-sm-6": (hidden || []).indexOf("from") === -1,
        "col-sm-12": ((hidden || []).indexOf("from") !== -1 || ((hidden || []).indexOf("customer") !== -1 && (hidden || []).indexOf("target") !== -1))
    })}>
        <div className="row form-row">
            <div className={classNames({
                "col-sm-12": ((hidden || []).indexOf("from") === -1 || (hidden || []).indexOf("target") !== -1),
                "col-sm-6": (hidden || []).indexOf("from") !== -1
            })}>
                {<CustomerComp {...propsTop} />}
            </div>
            <div className={classNames({
                "col-sm-12": ((hidden || []).indexOf("from") === -1 || (hidden || []).indexOf("customer") !== -1),
                "col-sm-6": (hidden || []).indexOf("from") !== -1
            })}>
                {<TargetComp {...propsTop} />}
            </div>
        </div>
    </div>
}